// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-audio-icons[data-v-0b526a53] {
  height: 120px;
  width: 100%;
  display: flex;
}
.phone-audio-icons.pause .icon[data-v-0b526a53]:not(:first-child) {
  opacity: 0.5;
}
.icon[data-v-0b526a53] {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
}
.icon[data-v-0b526a53]:first-child {
  margin-left: auto;
}
.icon[data-v-0b526a53]:last-child {
  margin-right: auto;
}
.icon[data-v-0b526a53]:not(:first-child) {
  margin-left: var(--negative-margine);
}
.icon .icon-image[data-v-0b526a53] {
  height: var(--icon-size);
  min-height: var(--icon-size);
  min-width: var(--icon-size);
  width: var(--icon-size);
  font-size: var(--font-size);
  border: var(--icon-border);
  line-height: 100%;
}
.icon .icon-pause-btn[data-v-0b526a53] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: var(--font-size);
  cursor: pointer;
  border-radius: 50%;
  -webkit-app-region: no-drag;
}
.impulse-animation-color[data-v-0b526a53] {
  -webkit-animation: impulse-0b526a53 2s linear infinite;
  animation: impulse-0b526a53 2s linear infinite;
}
@-webkit-keyframes impulse-0b526a53 {
0% {
    color: #ffffff;
}
50% {
    color: rgba(255, 255, 255, 0);
}
100% {
    color: #ffffff;
}
}
@keyframes impulse-0b526a53 {
0% {
    color: #ffffff;
}
50% {
    color: rgba(255, 255, 255, 0);
}
100% {
    color: #ffffff;
}
}
.impulse-animation-background[data-v-0b526a53] {
  -webkit-animation: impulsebackground-0b526a53 2s linear infinite;
  animation: impulsebackground-0b526a53 2s linear infinite;
}
@-webkit-keyframes impulsebackground-0b526a53 {
0% {
    background-color: rgba(0, 0, 0, 0.6);
}
50% {
    background-color: rgba(255, 255, 255, 0);
}
100% {
    background-color: rgba(0, 0, 0, 0.6);
}
}
@keyframes impulsebackground-0b526a53 {
0% {
    background-color: rgba(0, 0, 0, 0.6);
}
50% {
    background-color: rgba(255, 255, 255, 0);
}
100% {
    background-color: rgba(0, 0, 0, 0.6);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/PhoneAudioIcons.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,sDAAsD;EACtD,8CAA8C;AAChD;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;AACA;AACA;AACA;IACI,cAAc;AAClB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,cAAc;AAClB;AACA;AACA;EACE,gEAAgE;EAChE,wDAAwD;AAC1D;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;AACA;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,oCAAoC;AACxC;AACA","sourcesContent":[".phone-audio-icons[data-v-0b526a53] {\n  height: 120px;\n  width: 100%;\n  display: flex;\n}\n.phone-audio-icons.pause .icon[data-v-0b526a53]:not(:first-child) {\n  opacity: 0.5;\n}\n.icon[data-v-0b526a53] {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.icon[data-v-0b526a53]:first-child {\n  margin-left: auto;\n}\n.icon[data-v-0b526a53]:last-child {\n  margin-right: auto;\n}\n.icon[data-v-0b526a53]:not(:first-child) {\n  margin-left: var(--negative-margine);\n}\n.icon .icon-image[data-v-0b526a53] {\n  height: var(--icon-size);\n  min-height: var(--icon-size);\n  min-width: var(--icon-size);\n  width: var(--icon-size);\n  font-size: var(--font-size);\n  border: var(--icon-border);\n  line-height: 100%;\n}\n.icon .icon-pause-btn[data-v-0b526a53] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: var(--font-size);\n  cursor: pointer;\n  border-radius: 50%;\n  -webkit-app-region: no-drag;\n}\n.impulse-animation-color[data-v-0b526a53] {\n  -webkit-animation: impulse-0b526a53 2s linear infinite;\n  animation: impulse-0b526a53 2s linear infinite;\n}\n@-webkit-keyframes impulse-0b526a53 {\n0% {\n    color: #ffffff;\n}\n50% {\n    color: rgba(255, 255, 255, 0);\n}\n100% {\n    color: #ffffff;\n}\n}\n@keyframes impulse-0b526a53 {\n0% {\n    color: #ffffff;\n}\n50% {\n    color: rgba(255, 255, 255, 0);\n}\n100% {\n    color: #ffffff;\n}\n}\n.impulse-animation-background[data-v-0b526a53] {\n  -webkit-animation: impulsebackground-0b526a53 2s linear infinite;\n  animation: impulsebackground-0b526a53 2s linear infinite;\n}\n@-webkit-keyframes impulsebackground-0b526a53 {\n0% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n50% {\n    background-color: rgba(255, 255, 255, 0);\n}\n100% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n}\n@keyframes impulsebackground-0b526a53 {\n0% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n50% {\n    background-color: rgba(255, 255, 255, 0);\n}\n100% {\n    background-color: rgba(0, 0, 0, 0.6);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
